import { AutogenModelResponsibleHist, AutogenRowResponsibleHist } from "./autogen/AutogenModelResponsibleHist";

export class ModelResponsibleHist extends AutogenModelResponsibleHist<RowResponsibleHist> {
	constructor() {
		super(RowResponsibleHist);
	}
}

export class RowResponsibleHist extends AutogenRowResponsibleHist {
}